import { EditorState } from "draft-js";

export default function forceEditorSelection(
  editorState,
  selectionOptions = {}
) {
  let {
    anchorOffset,
    focusOffset,
    anchorKey,
    focusKey,
    isBackward,
    hasFocus,
  } = selectionOptions;
  const selection = editorState.getSelection();
  anchorKey = anchorKey || selection.getAnchorKey();
  anchorOffset = anchorOffset || 0;

  const newSelection = selection.merge({
    anchorKey,
    anchorOffset,
    hasFocus: hasFocus === undefined ? true : hasFocus,
    focusKey: focusKey || anchorKey,
    focusOffset: focusOffset === undefined ? anchorOffset : focusOffset,
    isBackward: isBackward || anchorOffset > focusOffset,
  });
  return EditorState.forceSelection(editorState, newSelection);
}
